import { useCallback } from 'react';
import { useEventDraftPatch, } from '@robinpowered/dashboard-apps-common';
import { ComposerMode } from '../types/index';
import { useAddSpaceFromSearch } from './useAddSpaceFromSearch';
/**
 * Subscribe to cross-app draft patches and append any `addSpaceId` they carry
 * to the composer's `spaces`. This is how the office "add to event" flow lands
 * a map-selected space into the parked composer: the office emits
 * `emitEventDraftPatch({ eventId, addSpaceId }, 'office')` and this hook (which
 * runs inside the composer's `FormProvider`, so `useAddSpaceFromSearch` has its
 * form + config context) fetches the full space and adds it.
 *
 * Space additions are handled here — directly inside patterns — rather than
 * via the shell's `EventComposerHandle`, because adding a space is an async
 * fetch + transform + de-dupe that already lives in `useAddSpaceFromSearch`;
 * reusing it keeps that logic in one place. The shell still owns the simpler
 * time/date patches it applies through the handle. The two are disjoint: a
 * given patch carries either time deltas or an `addSpaceId`, never both.
 */
export var useApplyExternalSpaceAddition = function (_a) {
    var mode = _a.mode, eventId = _a.eventId;
    var addSpaceById = useAddSpaceFromSearch().addSpaceById;
    useEventDraftPatch(useCallback(function (patch) {
        if (patch.addSpaceId === undefined)
            return;
        // Only apply patches aimed at *this* open.
        if (mode === ComposerMode.CREATE) {
            if (patch.eventId !== null)
                return;
        }
        else if (!eventId || patch.eventId !== eventId) {
            return;
        }
        var spaceId = Number(patch.addSpaceId);
        if (Number.isNaN(spaceId))
            return;
        void addSpaceById(spaceId);
    }, [mode, eventId, addSpaceById]));
};
